import { REDUX_ACTIONS } from '../global/constants';

export function updateFellowModels(fellowModels) {
  return {
    type: REDUX_ACTIONS.UPDATE_FELLOW_MODELS,
    fellowModels,
  };
}
